import { formatProvenanceDate } from '../../utils/provenance';

// D6: who reviewed an item and when. Every review write (fact, red flag,
// timeline event, diagnosis code, primary designation) carries one `review`
// object built here. reviewedAt is an ISO string, not serverTimestamp():
// red flags and code candidates live in arrays, and Firestore refuses
// serverTimestamp() inside an array. Each write's last_modified_date stays a
// server timestamp, and the Firestore Data Access audit log (D1) records the
// real caller of every write; the rules cannot pin a uid under a fact name.

/**
 * The signed-in reviewer. The name comes from the main users document, then
 * the auth display name. Never the email: a case document is readable by
 * colleagues, and #307 keeps emails off what colleagues can read.
 */
export function reviewerOf(user, userProfile) {
    return { uid: user.uid, name: userProfile?.name || user?.displayName || 'Unknown' };
}

/** The review object for one write. bulk is present only for a bulk action. */
export function reviewStamp(reviewer, { bulk = false, at = new Date() } = {}) {
    const stamp = {
        reviewedBy: reviewer.uid,
        reviewedByName: reviewer.name,
        reviewedAt: at.toISOString(),
    };
    if (bulk) stamp.bulk = true;
    return stamp;
}

/** A copy of the item without its review, for a return to pending. */
export function withoutReview(item) {
    const { review, ...rest } = item;
    return rest;
}

/** "Reviewed by Ann Lee on 10/7/2026", or null when the item has no review. */
export function reviewLine(review, verb = 'Reviewed') {
    if (!review?.reviewedBy) return null;
    const who = review.reviewedByName || 'Unknown';
    const how = review.bulk ? ' with Mark all' : '';
    return `${verb} by ${who} on ${formatProvenanceDate(review.reviewedAt)}${how}`;
}
